import { BaseContainerModel } from '../base-container.model';
import { bl_mrp_ppq_worklog_Rowclass } from '../../dbschema';

export class MrpPickPackQueueWorklogContainerModel extends BaseContainerModel {
  bl_mrp_ppq_worklog: bl_mrp_ppq_worklog_Rowclass = new bl_mrp_ppq_worklog_Rowclass();
}
